var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelayedDeliveriesTruckKpi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delayed deliveries"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250559",
    d: "M32.5181 0.444336V18.7036H47.8885V32.6666H1.77734V0.444336H32.5181Z",
    fill: "#F2CA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250560",
    d: "M46.7776 20.0475L41.3124 9.33325H32.8887V24.3333",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 676",
    d: "M17.9431 36.2778C17.9431 38.8926 15.7042 41.0556 12.8876 41.0556C10.071 41.0556 7.83203 38.8926 7.83203 36.2778C7.83203 33.6629 10.071 31.5 12.8876 31.5C15.7042 31.5 17.9431 33.6629 17.9431 36.2778Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 677",
    d: "M42.9431 36.2778C42.9431 38.8926 40.7042 41.0556 37.8876 41.0556C35.071 41.0556 32.832 38.8926 32.832 36.2778C32.832 33.6629 35.071 31.5 37.8876 31.5C40.7042 31.5 42.9431 33.6629 42.9431 36.2778Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250562",
    d: "M0.666016 6H22.8882",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250563",
    d: "M0.666016 10.4443L12.8882 10.4443",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250564",
    d: "M0.666016 14.3333L6.22157 14.3333",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedDeliveriesTruckKpi);
export default __webpack_public_path__ + "static/media/Delayed_deliveries_truckKPI.676a9dbdd1a2ededfba3f7f8393a4828.svg";
export { ForwardRef as ReactComponent };